export default __webpack_public_path__ + "img/elipse-bege.png";